import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { MaskedLines, FadeUp } from "./Reveal";

export default function PageHero({ eyebrow, title, lead, testid }) {
  return (
    <header className="relative overflow-hidden pb-14 pt-28 sm:pb-16 sm:pt-36" data-testid={testid}>
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-40 -top-40 h-[480px] w-[480px] rounded-full opacity-25 blur-3xl"
        style={{
          background:
            "conic-gradient(from 90deg, #F0609D, #FFCF3F, #2BB5A0, #6A5FC1, #F0609D)",
        }}
      />
      <div className="container-x relative">
        <FadeUp y={14}>
          <span className="chip" data-testid={`${testid}-eyebrow`}>
            <span className="dot bg-rainbow" />
            {eyebrow}
          </span>
        </FadeUp>
        <MaskedLines
          as="h1"
          lines={title}
          className="mt-6 max-w-4xl font-display text-4xl leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl"
          testid={`${testid}-title`}
        />
        {lead && (
          <FadeUp delay={0.45}>
            <p className="mt-7 max-w-2xl text-lg leading-relaxed text-mute" data-testid={`${testid}-lead`}>
              {lead}
            </p>
          </FadeUp>
        )}
      </div>
    </header>
  );
}

export function NextPage({ to, label, title, testid }) {
  return (
    <FadeUp>
      <Link
        to={to}
        data-testid={testid}
        className="group mt-4 flex items-center justify-between gap-6 rounded-3xl border border-line bg-white px-7 py-6 transition-[transform,box-shadow] duration-200 hover:-translate-y-1 hover:shadow-[0_20px_40px_-24px_rgba(45,55,72,0.4)] sm:px-9 sm:py-8"
      >
        <div>
          <p className="eyebrow">Next</p>
          <p className="mt-2 font-display text-2xl text-ink sm:text-3xl">{title}</p>
          <p className="mt-1 text-sm text-mute">{label}</p>
        </div>
        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-ink text-white transition-transform duration-200 group-hover:translate-x-1">
          <ArrowRight className="h-5 w-5" strokeWidth={1.5} />
        </span>
      </Link>
    </FadeUp>
  );
}
